
export const Logo = process.env.REACT_APP_LOGO
export const LogoDark = process.env.REACT_APP_LOGO_DARK
export const LogoSecondary = process.env.REACT_APP_LOGO_SECONDARY